var ImageAnimationType;
(function (ImageAnimationType) {
    ImageAnimationType["FadeIn"] = "fade-in";
    ImageAnimationType["FadeUp"] = "fade-up";
    ImageAnimationType["FadeDown"] = "fade-down";
    ImageAnimationType["FadeInRight"] = "fade-in-right";
    ImageAnimationType["FadeInLeft"] = "fade-in-left";
    ImageAnimationType["None"] = "";
})(ImageAnimationType || (ImageAnimationType = {}));

export { ImageAnimationType };
//# sourceMappingURL=animation.esm.js.map
